import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig, countries, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterTypeDocumentView.
 * @extends JetView
 */
export default class FilterTypeDocumentView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section with a text input for Reference
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Reference',
                    label: _('Referencia'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Referencia'), // Localized placeholder
                },
            ],
        };

        // Center left section with a text input for Name
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Name',
                    label: _('Nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Nombre'), // Localized placeholder
                },
            ],
        };

        // Center right section with two richselect components for country selection
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'CountrySelect',
                    id: 'CountrySelect',
                    localId: 'regions:combo',
                    label: "<span class='icon-language'></span>" + _('País'), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: {
                        body: {
                            template: function (obj) {
                                return (
                                    "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                );
                            },
                            data: countries, // Data source for countries
                        },
                    },
                    hidden:
                        devConfig.getCountryReport() || // Conditional visibility based on configuration
                        !devConfig.getPermAction('filterByCountry', 'Add'),
                    css: 'prm-filterByCountry', // CSS class for styling
                },
                {
                    view: 'richselect',
                    name: 'CountrySelect2',
                    localId: 'regions:combo',
                    label: "<span class='icon-language'></span>" + _('País'), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    value: profile.Settings.ReportCountry, // Default value from profile settings
                    readonly: true, // Read-only field
                    options: {
                        body: {
                            template: function (obj) {
                                return (
                                    "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                );
                            },
                            data: countries, // Data source for countries
                        },
                    },
                    hidden:
                        !devConfig.getCountryReport() || // Conditional visibility based on configuration
                        !devConfig.getPermAction('filterByCountry', 'Add'),
                    css: 'prm-filterByCountry', // CSS class for styling
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [{}],
        };

        // Upper section containing the main layout
        const upper_section = {
            css: 'father-container', // CSS class for styling
            height: document.body.offsetWidth < 500 ? 300 : 0, // Responsive height
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive behavior
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout columns
                },
            ],
        };

        // Button section with actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Centro'), // Localized button label
                    type: 'form',
                    autowidth: true,
                    hidden: !devConfig.getPermAction(
                        'accountingTypeDocumentAdd',
                        'Add', // Conditional visibility based on permissions
                    ),
                    css: 'prm-accountingTypeDocumentAdd', // CSS class for styling
                    click: () => {
                        this.app.callEvent('addTypeDocument:button', [{}]); // Event call on button click
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Localized button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form fields on button click
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Localized button label
                    hotkey: 'enter', // Keyboard shortcut
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('typeDocument:filter', [filterdata]); // Event call with filter data
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Form layout
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and fetches data from the API.
     */
    init() {
        webix
            .ajax() // AJAX request to fetch data
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(
                devConfig.geturlApi() + // API URL from configuration
                    'Accounting/GetTypesCenterPositionSelect',
                '{"Type":0}', // Request payload
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Display error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response data
                        $$('TypeCenter').define('options', resp.Data); // Update options for TypeCenter
                        $$('TypeCenter').refresh(); // Refresh the component
                    },
                },
            );
    }
}

// FILE DOCUMENTED
